import api from './api';

const tipoEquipoService = {
  getTiposEquipo: async () => {
    try {
      const response = await api.get('/api/tipos-equipo');
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener tipos de equipo';
    }
  },

  getTipoEquipo: async (tipoId) => {
    try {
      const response = await api.get(`/api/tipos-equipo/${tipoId}`);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al obtener tipo de equipo';
    }
  },

  createTipoEquipo: async (tipoData) => {
    try {
      const response = await api.post('/api/tipos-equipo', tipoData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al crear tipo de equipo';
    }
  },

  updateTipoEquipo: async (tipoId, tipoData) => {
    try {
      const response = await api.put(`/api/tipos-equipo/${tipoId}`, tipoData);
      return response.data;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al actualizar tipo de equipo';
    }
  },

  deleteTipoEquipo: async (tipoId) => {
    try {
      await api.delete(`/api/tipos-equipo/${tipoId}`);
      return true;
    } catch (error) {
      if (error.response?.data?.detail) {
        if (Array.isArray(error.response.data.detail)) {
          throw error.response.data.detail.map(e => e.msg).join(', ');
        }
        throw error.response.data.detail;
      }
      throw error.message || 'Error al desactivar tipo de equipo';
    }
  }
};

export default tipoEquipoService;